import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import initContainerData from 'bdata-react-component/lib/store/initContainerData';

import contentGraphDatasource from '@gameday/core/datasources/contentGraph';
import contentDatasource from '@gameday/core/datasources/content';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';

import { getHighlightsPlaylist } from '../store/selectors/highlightsPlaylistSelector';
import highlightsPlaylistDataRequestAction from '../store/actions/highlightsPlaylistDataRequestAction';
import highlightsPlaylistReducer from '../store/reducers/highlightsplaylist';

import HighlightsPlaylist from '../HighlightsPlaylist';

initContainerData.register({
    datasources: {
        content: contentDatasource,
        contentGraph: contentGraphDatasource
    },
    reducers: {
        highlightsplaylist: highlightsPlaylistReducer
    }
});

const fetchData = () => {
    return highlightsPlaylistDataRequestAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

export { fetchData, routes };

export const HighlightsPlaylistDataContainer = ({
    extendedDisplay,
    autoPlay,
    mute,
    captions
}) => {
    const {
        highlights,
        isLoading,
        defaultVideoSlug,
        gamePk
    } = useSelector(getHighlightsPlaylist);

    return (
        <ErrorBoundaryWrapper componentName='HighlightsPlaylist'>
            <HighlightsPlaylist
                extendedDisplay={extendedDisplay}
                autoPlay={autoPlay}
                mute={mute}
                captions={captions}
                highlights={highlights}
                isLoading={isLoading}
                defaultVideoSlug={defaultVideoSlug}
                gamePk={gamePk}
            />
        </ErrorBoundaryWrapper>
    );
};

HighlightsPlaylistDataContainer.propTypes = {
    autoPlay: PropTypes.bool,
    captions: PropTypes.bool,
    extendedDisplay: PropTypes.bool,
    mute: PropTypes.bool
};

export default memo(HighlightsPlaylistDataContainer);
